import {
  Box,
  Button,
  Card,
  CardHeader,
  Container,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import GetAppIcon from '@mui/icons-material/GetApp';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import { TableHeaderCell } from 'src/components/TableHeaderCell';
import { withStyles } from '@mui/styles';

import { useForm } from 'react-hook-form';
import styled from '@emotion/styled';
import {
  getAllBillingRoles,
  getAllTracks,
  searchEmployee
} from 'src/services/employeeService';
import { useSelector } from 'react-redux';
import { RootStateType } from 'src/store/RootReducer';
import {
  getAllEmployeesTimeSheet,
  searchTimeSheet,
  searchTimeSheetFilter
} from 'src/services/timesheetService';

interface Filters {
  type: string;
  po_status: string;
  status: string;
  cat: string;
}

const applyFilters = (employees: any[], filters: Filters): any[] => {
  return employees.filter((employeeStatus) => {
    let matches = true;
    // if (filters.status && employeeStatus.status !== filters.status) {
    //   matches = false;
    // }
    return matches;
  });
};

const applyPagination = (
  employees: any[],
  page: number,
  limit: number
): any[] => {
  return employees.slice(page * limit, page * limit + limit);
};

const WeeklyTimeSheetTable = () => {
  const navigate = useNavigate();
  const [toggleFilter, setToggleFilter] = useState(false);
  const [page, setPage] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [sortIdType, setSortIdType] = useState('desc');
  const [filters, setFilters] = useState<Filters>({
    type: null,
    po_status: null,
    status: null,
    cat: null
  });
  var initalList: any[] = [];
  const [employees, setEmployees] = useState(initalList);

  let initialProjectFilterValues = {
    designation: null,
    trackCode: null,
    year: null,
    week: null
  } as any;

  const { register, handleSubmit, reset, getValues, setValue } = useForm<any>({
    defaultValues: initialProjectFilterValues
  });
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    if (employees?.length > 0 && sortIdType === 'asc') {
      setEmployees(employees.sort((a, b) => a.name.localeCompare(b.name)));
    } else if (employees?.length > 0 && sortIdType === 'desc') {
      setEmployees(employees.sort((a, b) => b.name.localeCompare(a.name)));
    }
  }, [employees, sortIdType]);

  const filteredEmployees = applyFilters(employees, filters);

  const paginatedEmployees = applyPagination(filteredEmployees, page, limit);

  const handlePageChange = (event: any, newPage: number): void => {
    setPage(newPage);
  };

  const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setLimit(parseInt(event.target.value));
  };

  const getEmployeeData = () => {
    getAllEmployeesTimeSheet().then((res) => {
      setEmployees((res.data as any[]) || []);
    });
  };

  useEffect(() => {
    getEmployeeData();
  }, []);

  const CustomTableRow = withStyles({
    root: {
      background: '#E6E9FF !important',
      height: '3.5rem'
    }
  })(TableRow);

  const [empFilter, setEmpFilter] = useState({} as any);

  const onSubmit = (data: any) => {
    searchTimeSheetFilter(data).then((res) => {
      setEmployees((res.data as any[]) || []);
    });
  };

  const resetFilterResult = () => {
    reset();
    setEmpFilter(initialProjectFilterValues);
    getEmployeeData();
  };

  const [searchKeywords, setSearchKeywords] = useState('');

  //when user started to type the name in the text field
  const nameChange = (e) => {
    setSearchKeywords(e.target.value);
  };

  const searchTimeSheetAll = async (keyword: string) => {
    const result = await searchTimeSheet(keyword);
    setEmployees(result?.data);
  };

  useEffect(() => {
    if (searchKeywords.length > 3) {
      searchTimeSheetAll(searchKeywords);
    }
    if (searchKeywords.length === 0) {
      getEmployeeData();
    }
  }, [searchKeywords]);

  const CardHeaderWrapper = styled(CardHeader)(
    () => `
      .MuiCardHeader-action{
        width: 100%
      }
    `
  );

  useEffect(() => {
    const isNullish = Object.values(empFilter).every((value) => {
      if (value === null) {
        return true;
      }

      return false;
    });

    if (Object.keys(empFilter).length === 0 || isNullish) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [empFilter]);

  const [billingRoles, setBillingRoles] = useState<any>([]);
  const [tracks, setTracks] = useState<any>([]);

  useEffect(() => {
    getAllBillingRoles().then((res) => setBillingRoles(res.data));
    getAllTracks().then((res) => setTracks(res.data));
  }, []);

  return (
    <>
      <PageTitleWrapper>
        <Grid container alignItems="center" direction={'row'}>
          <Grid item>
            <Typography
              onClick={() => {
                navigate('/dashboard');
              }}
              style={{ cursor: 'pointer' }}
              variant="h4"
              component="h4"
            >
              {' '}
              Dashboard /&nbsp;
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              style={{ fontWeight: 'normal' }}
              variant="h4"
              component="h4"
            >
              Weekly Time Sheet Summary
            </Typography>
          </Grid>
          <Grid
            item
            display="flex"
            justifyContent="flex-end"
            style={{ marginLeft: 'auto' }}
          >
            <Button
              sx={{
                mt: { xs: 2, md: 0 },
                fontSize: '11px',
                fontWeight: 'normal'
              }}
              variant="contained"
              startIcon={<GetAppIcon fontSize="small" />}
              style={{ height: '1.75rem' }}
              // onClick={handleClickOpen}
            >
              Download Report
            </Button>
          </Grid>
        </Grid>
      </PageTitleWrapper>
      <Container maxWidth="lg">
        <Card>
          <Grid
            container
            style={{
              justifyContent: 'space-between',
              padding: '1rem 1rem 0rem 1rem'
            }}
            spacing={2}
          >
            <Grid item xs={6}>
              <TextField
                sx={{ width: 150, mr: 2 }}
                size="small"
                placeholder="Search..."
                onChange={(e) => nameChange(e)}
                InputProps={{
                  style: { fontSize: '12px', height: '1.75rem' },
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon
                        sx={{ color: '#d3d3d3' }}
                        style={{ fontSize: '15px' }}
                      />
                    </InputAdornment>
                  )
                }}
              />
              <Button
                sx={{
                  mt: { xs: 2, md: 0 },
                  color: `${!toggleFilter && 'gray'}`
                }}
                variant="outlined"
                startIcon={<FilterListIcon />}
                onClick={() => {
                  setToggleFilter(!toggleFilter);
                }}
                style={{ height: '1.75rem', fontSize: '12px' }}
              >
                Filters
              </Button>
            </Grid>
          </Grid>
          <CardHeaderWrapper
            action={
              <>
                <form onSubmit={handleSubmit(onSubmit)}>
                  {toggleFilter ? (
                    <>
                      <Grid
                        container
                        sx={{ pr: 2 }}
                        spacing={2}
                        style={{
                          paddingTop: 3,
                          paddingBottom: 2,
                          justifyContent: 'space-between'
                        }}
                      >
                        <Grid item xs={3}>
                          <FormControl fullWidth>
                            <InputLabel
                              style={{
                                fontSize: '12px'
                              }}
                            >
                              Designation
                            </InputLabel>
                            <Select
                              sx={{ mt: 1 }}
                              style={{
                                fontSize: '12px',
                                height: '2rem'
                              }}
                              autoWidth
                              size="small"
                              {...register('designation')}
                              value={empFilter.designation}
                              onChange={(e) => {
                                setEmpFilter((prev) => ({
                                  ...prev,
                                  designation: e.target.value
                                }));
                                setValue('designation', e.target.value);
                              }}
                            >
                              {(billingRoles || []).map((item, i) => {
                                return (
                                  <MenuItem value={item.name} key={i}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                          <FormControl fullWidth>
                            <InputLabel
                              style={{
                                fontSize: '12px'
                              }}
                            >
                              Track Code
                            </InputLabel>
                            <Select
                              sx={{ mt: 1 }}
                              style={{
                                fontSize: '12px',
                                height: '2rem'
                              }}
                              autoWidth
                              size="small"
                              value={empFilter.trackCode}
                              {...register('trackCode')}
                              onChange={(e) => {
                                setEmpFilter((prev) => ({
                                  ...prev,
                                  trackCode: e.target.value
                                }));
                                setValue('trackCode', e.target.value);
                              }}
                            >
                              {(tracks || []).map((item, i) => {
                                return (
                                  <MenuItem value={item.code} key={i}>
                                    {item.code}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                          <FormControl fullWidth>
                            <InputLabel
                              style={{
                                fontSize: '12px'
                              }}
                            >
                              Year
                            </InputLabel>
                            <Select
                              className="select-text"
                              style={{
                                fontSize: '12px',
                                height: '2rem'
                              }}
                              sx={{ mt: 1 }}
                              autoWidth
                              size="small"
                              value={empFilter.year}
                              {...register('year')}
                              onChange={(e) => {
                                setEmpFilter((prev) => ({
                                  ...prev,
                                  year: e.target.value
                                }));
                                setValue('year', e.target.value);
                              }}
                            >
                              <MenuItem value={'2016'}>{'2016'}</MenuItem>
                              <MenuItem value={'2017'}>{'2017'}</MenuItem>
                              <MenuItem value={'2018'}>{'2018'}</MenuItem>
                              <MenuItem value={'2019'}>{'2019'}</MenuItem>
                              <MenuItem value={'2020'}>{'2020'}</MenuItem>
                              <MenuItem value={'2021'}>{'2021'}</MenuItem>
                              <MenuItem value={'2022'}>{'2022'}</MenuItem>
                              <MenuItem value={'2023'}>{'2023'}</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                          <FormControl fullWidth>
                            <InputLabel
                              style={{
                                fontSize: '12px'
                              }}
                            >
                              Week
                            </InputLabel>
                            <Select
                              className="select-text"
                              style={{
                                fontSize: '12px',
                                height: '2rem'
                              }}
                              sx={{ mt: 1 }}
                              autoWidth
                              size="small"
                              value={empFilter.week}
                              {...register('week')}
                              onChange={(e) => {
                                setEmpFilter((prev) => ({
                                  ...prev,
                                  week: e.target.value
                                }));
                                setValue('week', e.target.value);
                              }}
                            >
                              <MenuItem value={'1'}>{'1'}</MenuItem>
                              <MenuItem value={'2'}>{'2'}</MenuItem>
                              <MenuItem value={'3'}>{'3'}</MenuItem>
                              <MenuItem value={'4'}>{'4'}</MenuItem>
                              <MenuItem value={'5'}>{'5'}</MenuItem>
                              <MenuItem value={'6'}>{'6'}</MenuItem>
                              <MenuItem value={'7'}>{'7'}</MenuItem>
                              <MenuItem value={'8'}>{'8'}</MenuItem>
                              <MenuItem value={'9'}>{'9'}</MenuItem>
                              <MenuItem value={'10'}>{'10'}</MenuItem>
                              <MenuItem value={'11'}>{'11'}</MenuItem>
                              <MenuItem value={'12'}>{'12'}</MenuItem>
                              <MenuItem value={'13'}>{'13'}</MenuItem>
                              <MenuItem value={'14'}>{'14'}</MenuItem>
                              <MenuItem value={'15'}>{'15'}</MenuItem>
                              <MenuItem value={'16'}>{'16'}</MenuItem>
                              <MenuItem value={'17'}>{'17'}</MenuItem>
                              <MenuItem value={'18'}>{'18'}</MenuItem>
                              <MenuItem value={'19'}>{'19'}</MenuItem>
                              <MenuItem value={'20'}>{'20'}</MenuItem>
                              <MenuItem value={'21'}>{'21'}</MenuItem>
                              <MenuItem value={'22'}>{'22'}</MenuItem>
                              <MenuItem value={'23'}>{'23'}</MenuItem>
                              <MenuItem value={'24'}>{'24'}</MenuItem>
                              <MenuItem value={'25'}>{'25'}</MenuItem>
                              <MenuItem value={'26'}>{'26'}</MenuItem>
                              <MenuItem value={'27'}>{'27'}</MenuItem>
                              <MenuItem value={'28'}>{'28'}</MenuItem>
                              <MenuItem value={'29'}>{'29'}</MenuItem>
                              <MenuItem value={'30'}>{'30'}</MenuItem>
                              <MenuItem value={'31'}>{'31'}</MenuItem>
                              <MenuItem value={'32'}>{'32'}</MenuItem>
                              <MenuItem value={'33'}>{'33'}</MenuItem>
                              <MenuItem value={'34'}>{'34'}</MenuItem>
                              <MenuItem value={'35'}>{'35'}</MenuItem>
                              <MenuItem value={'36'}>{'36'}</MenuItem>
                              <MenuItem value={'37'}>{'37'}</MenuItem>
                              <MenuItem value={'38'}>{'38'}</MenuItem>
                              <MenuItem value={'39'}>{'39'}</MenuItem>
                              <MenuItem value={'40'}>{'40'}</MenuItem>
                              <MenuItem value={'41'}>{'41'}</MenuItem>
                              <MenuItem value={'42'}>{'42'}</MenuItem>
                              <MenuItem value={'43'}>{'43'}</MenuItem>
                              <MenuItem value={'44'}>{'44'}</MenuItem>
                              <MenuItem value={'45'}>{'45'}</MenuItem>
                              <MenuItem value={'46'}>{'46'}</MenuItem>
                              <MenuItem value={'47'}>{'47'}</MenuItem>
                              <MenuItem value={'48'}>{'48'}</MenuItem>
                              <MenuItem value={'49'}>{'49'}</MenuItem>
                              <MenuItem value={'50'}>{'50'}</MenuItem>
                              <MenuItem value={'51'}>{'51'}</MenuItem>
                              <MenuItem value={'52'}>{'52'}</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                      <Grid
                        sx={{ pr: 2 }}
                        container
                        style={{ justifyContent: 'flex-end', marginTop: 4 }}
                        xs={12}
                      >
                        <Button
                          sx={{ mt: { xs: 2, md: 0 }, mr: 2 }}
                          variant="text"
                          onClick={resetFilterResult}
                          disabled={isDisabled}
                          style={{ height: '1.75rem', fontSize: '12px' }}
                        >
                          Clear
                        </Button>
                        <Button
                          sx={{ mt: { xs: 2, md: 0 } }}
                          disabled={isDisabled}
                          variant="outlined"
                          type="submit"
                          style={{ height: '1.75rem', fontSize: '12px' }}
                        >
                          Filter
                        </Button>
                      </Grid>
                    </>
                  ) : (
                    <></>
                  )}
                </form>
              </>
            }
            title=""
          />
          <TableContainer className="tableContainer">
            <Table size="small">
              <TableHead>
                <CustomTableRow>
                  <TableHeaderCell
                    content="Employee Name"
                    sort
                    setSortType={setSortIdType}
                    sortType={sortIdType}
                    smallFont
                  />
                  <TableHeaderCell content="Designation" smallFont />
                  <TableHeaderCell content="Employee Track Code" smallFont />
                  <TableHeaderCell content="Expected Weekly Hours" smallFont />
                  <TableHeaderCell content="Actual Work Hours" smallFont />
                  <TableHeaderCell content="Actual Vs Expected Hrs" smallFont />
                </CustomTableRow>
              </TableHead>
              <TableBody>
                {paginatedEmployees &&
                  paginatedEmployees?.length > 0 &&
                  paginatedEmployees.map((listItem) => {
                    return (
                      <TableRow hover key={listItem.code}>
                        <TableCell>
                          <Typography
                            variant="body2"
                            style={{ fontSize: '11px' }}
                            gutterBottom
                            noWrap
                          >
                            {listItem.name}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant="body2"
                            style={{ fontSize: '11px' }}
                            gutterBottom
                            noWrap
                          >
                            {listItem.designation}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant="body2"
                            style={{ fontSize: '11px' }}
                            color="text.primary"
                            gutterBottom
                            noWrap
                          >
                            {listItem.trackCode}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant="body2"
                            style={{ fontSize: '11px' }}
                            color="text.primary"
                            gutterBottom
                            noWrap
                          >
                            {listItem.expectedWorkedHours}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant="body2"
                            style={{ fontSize: '11px' }}
                            color="text.primary"
                            gutterBottom
                            noWrap
                          >
                            {listItem.workedHours}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant="body2"
                            style={{ fontSize: '11px' }}
                            color="text.primary"
                            gutterBottom
                            noWrap
                          >
                            {listItem.workedHours -
                              listItem.expectedWorkedHours}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          {/* {paginatedweeklyProjectWork?.length === 0 && (
          <Typography
            style={{
              fontSize: '15px',
              fontWeight: 'bold',
              margin: '1rem',
              textAlign: 'center'
            }}
            variant="body2"
          >
            No Records Found
          </Typography>
        )} */}
          <Box p={2}>
            <TablePagination
              sx={{
                fontSize: '12px',
                '.MuiTablePagination-displayedRows': {
                  fontSize: '12px'
                },
                '.MuiTablePagination-selectLabel': {
                  fontSize: '12px'
                }
              }}
              component="div"
              count={filteredEmployees?.length}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleLimitChange}
              page={page}
              rowsPerPage={limit}
              rowsPerPageOptions={[10, 20, 30, 40, 50]}
            />
          </Box>
        </Card>
      </Container>
    </>
  );
};

export default WeeklyTimeSheetTable;
